import React from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";


class LoginForm extends React.Component {
    constructor() {
        super();

        this.state = {
            phone: "",
            password: "",
            staticPassword: "",
            isLoggedIn: false,
            checkPhone: false,
            error: null,
            passwordSent: false,
            loginMode: 'otp' // 'otp' یا 'static'
        };
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    // تغییر حالت ورود
    toggleLoginMode = () => {
        const newMode = this.state.loginMode === 'otp' ? 'static' : 'otp';
        this.setState({
            loginMode: newMode,
            error: null,
            password: '',
            staticPassword: '',
            checkPhone: false,
            passwordSent: false
        });
    }

    submitPhone = async event => {
        event.preventDefault();

        const { phone } = this.state;
        await axios.post(window.base_URL + "/login", { phone })
            .then(() => {
                this.setState({
                    phone,
                    checkPhone: true,
                    passwordSent: true
                });
            })
            .catch(err => {
                console.error(err)
                if (err.response) {
                    this.setState({
                        error: err.response,
                        passwordSent: false
                    });
                }
            })
    };

    // متد جدید برای ورود با رمز ثابت
    submitStaticPassword = async event => {
        event.preventDefault();

        const { phone, staticPassword } = this.state;

        // اعتبارسنجی ساده
        if (!phone || !staticPassword) {
            this.setState({
                error: { data: { message: 'شماره تلفن و رمز ثابت الزامی است' } }
            });
            return;
        }

        try {
            const res = await axios.post(window.base_URL + "/verify-static", {
                phone,
                staticPassword
            });

            sessionStorage.setItem('client', JSON.stringify(res.data.result.client));
            sessionStorage.setItem('token', JSON.stringify(res.data.result.token));

            var now = new Date();
            var time = now.getTime();
            var expireTime = time + (30 * 24 * 60 * 60 * 1000);
            now.setTime(expireTime);
            document.cookie = "token=" + res.data.result.token + ';expires=' + now.toUTCString() + ';path=/';
            axios.defaults.headers.common['x-auth-token'] = sessionStorage.getItem('token');

            window.location.href = "profile";
        } catch (err) {
            console.error(err);
            if (err.response) {
                this.setState({
                    error: err.response,
                    passwordSent: false
                });
            }
        }
    };

    submitPassword = async event => {
        event.preventDefault();
        this.verifyLoading = true;
        const { phone, password } = this.state;
        await axios.post(window.base_URL + "/verify", { phone, password })
            .then(res => {
                sessionStorage.setItem('client', JSON.stringify(res.data.result.client));
                sessionStorage.setItem('token', JSON.stringify(res.data.result.token));
                var now = new Date();
                var time = now.getTime();
                var expireTime = time + (30 * 24 * 60 * 60 * 1000);
                now.setTime(expireTime);
                document.cookie = "token=" + res.data.result.token + ';expires=' + now.toUTCString() + ';path=/';
                axios.defaults.headers.common['x-auth-token'] = sessionStorage.getItem('token');

                window.location.href = "profile";
            })
            .catch(err => {
                console.error(err);
                if (err.response) {
                    this.setState({
                        error: err.response,
                        passwordSent: false
                    });
                }
            })
    };

    // متد برای تعیین onSubmit بر اساس حالت
    handleSubmit = (event) => {
        event.preventDefault();

        if (this.state.loginMode === 'static') {
            this.submitStaticPassword(event);
        } else if (this.state.checkPhone) {
            this.submitPassword(event);
        } else {
            this.submitPhone(event);
        }
    };

    // متد کمکی برای نمایش خطا
    getErrorMessage = () => {
        const { error } = this.state;
        if (error && error.data && error.data.message) {
            return error.data.message;
        }
        return 'خطا در ورود به سیستم';
    };

    render() {

        if (this.state.isLoggedIn) {
            return <Redirect to="/" />;
        }

        const {
            phone,
            password,
            staticPassword,
            error,
            passwordSent,
            loginMode,
            checkPhone
        } = this.state;

        const isOtpMode = loginMode === 'otp';
        const isStaticMode = loginMode === 'static';

        return (
            <div className='login-form card'>
                <form className='card-body text-right p-5' onSubmit={this.handleSubmit} dir='rtl'>

                    {/* شماره تلفن - در هر دو حالت نمایش داده می‌شود */}
                    <div className="form-group">
                        <label htmlFor="phone">شماره تلفن</label>
                        <input
                            dir='ltr'
                            name='phone'
                            className="form-control rounded-pill no-spinners"
                            type="number"
                            value={phone}
                            onChange={this.handleChange}
                            placeholder="09..."
                            required
                        />
                    </div>

                    {/* حالت رمز یکبار مصرف (OTP) */}
                    {isOtpMode && (
                        <div>
                            {!checkPhone ? (
                                // مرحله اول - درخواست رمز
                                <div className="form-group">
                                    <button
                                        type="submit"
                                        className='ps-btn w-100'
                                    >
                                        ارسال رمز
                                    </button>
                                </div>
                            ) : (
                                // مرحله دوم - وارد کردن رمز دریافتی
                                <div className="form-group">
                                    <div className="alert alert-success text-right" role="alert">
                                        رمز عبور برای شما از طریق پیامک ارسال شد.
                                    </div>
                                    <label htmlFor="password">رمز عبور ارسالی از طریق پیامک</label>
                                    <input
                                        dir='ltr'
                                        className="form-control rounded-pill"
                                        name='password'
                                        type="password"
                                        value={password}
                                        placeholder="رمز عبور"
                                        onChange={this.handleChange}
                                        required
                                    />
                                    <button type="submit" className='ps-btn w-100 mt-3'>
                                        ورود
                                    </button>
                                </div>
                            )}
                        </div>
                    )}

                    {/* حالت رمز ثابت */}
                    {isStaticMode && (
                        <div className="form-group">
                            <label htmlFor="staticPassword">رمز ثابت</label>
                            <input
                                dir='ltr'
                                className="form-control rounded-pill"
                                name='staticPassword'
                                type="password"
                                value={staticPassword}
                                placeholder="رمز ثابت خود را وارد کنید"
                                onChange={this.handleChange}
                                required
                            />
                            <button type="submit" className='ps-btn w-100 mt-3'>
                                ورود با رمز ثابت
                            </button>
                        </div>
                    )}

                    {/* نمایش خطاها */}
                    {error && (
                        <div className="alert alert-danger text-right mt-3" role="alert">
                            {this.getErrorMessage()}
                        </div>
                    )}

                    {/* دکمه تغییر حالت ورود - در پایین */}
                    <div className="text-center mt-3">
                        <button
                            type="button"
                            className="shadow-sm rounded-pill form-control form-control-sm"
                            onClick={this.toggleLoginMode}
                        >
                            {isOtpMode ? 'ورود با رمز ثابت' : 'ورود با رمز یکبار مصرف'}
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

export default LoginForm;